/**
 * AutofillDraftModal — review the AI-extracted marketplace draft from the
 * teacher's CV before saving. Extracted from MarketplaceSettings.
 */
import { Button } from "@/components/ui/button";
import { Banknote, Check, Zap } from "lucide-react";
import { DraftRow, DraftListRow } from "./SettingsFields";

export default function AutofillDraftModal({ draft, setDraft, onApply, onClose }) {
  if (!draft) return null;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm grid place-items-center p-3"
      onClick={onClose}
      data-testid="autofill-modal"
    >
      <div className="bg-card rounded-3xl border border-border max-w-lg w-full p-5 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 mb-3">
          <span className="h-9 w-9 rounded-xl tb-chip-butter grid place-items-center"><Zap className="h-4 w-4" /></span>
          <div>
            <p className="font-display text-lg font-medium tracking-tight">Review your auto-filled draft</p>
            <p className="text-[11px] text-muted-foreground">Extracted by TeeBee Intelligence from your CV. Edit anything before saving.</p>
          </div>
        </div>
        <div className="space-y-2 text-sm max-h-[60vh] overflow-y-auto">
          <DraftRow label="Headline" value={draft.headline} onChange={(v) => setDraft({ ...draft, headline: v })} />
          <DraftRow label="Years of experience" type="number" value={draft.experience_years} onChange={(v) => setDraft({ ...draft, experience_years: v ? parseInt(v, 10) : null })} />
          <DraftListRow label="Teaching categories" value={draft.teaching_categories} onChange={(v) => setDraft({ ...draft, teaching_categories: v })} />
          <DraftListRow label="Subjects"             value={draft.subjects}             onChange={(v) => setDraft({ ...draft, subjects: v })} />
          <DraftListRow label="Grade levels"         value={draft.grade_levels}         onChange={(v) => setDraft({ ...draft, grade_levels: v })} />
          <DraftListRow label="Languages"            value={draft.languages_taught}     onChange={(v) => setDraft({ ...draft, languages_taught: v })} />
          {draft.suggested_salary_min && (
            <div className="text-[11px] text-muted-foreground p-2 rounded-xl bg-muted/40 flex items-center gap-2">
              <Banknote className="h-3 w-3" /> Suggested salary band: ₹{draft.suggested_salary_min.toLocaleString()}–₹{(draft.suggested_salary_max || draft.suggested_salary_min).toLocaleString()}/mo
            </div>
          )}
        </div>
        <div className="mt-4 flex gap-2 justify-end">
          <Button variant="outline" className="rounded-full" onClick={onClose} data-testid="autofill-cancel">Cancel</Button>
          <Button className="rounded-full" onClick={onApply} data-testid="autofill-apply">
            <Check className="h-3.5 w-3.5 mr-1.5" /> Save to my profile
          </Button>
        </div>
      </div>
    </div>
  );
}
